<template>
    <div>
        <router-link @click.native="addView(tool.id)" :to="'/listing-detail/' + tool.id" tag="div" v-for="(tool, index) in tools" :key="index">
            <ToolListItem :imageLarge="['sm', 'lg']" :tool="tool">
                <template slot="content">
                    <div :class="{'flex items-center justify-between' : xs}">
                        <div>
                            <div class="mt2 f7"><span class="b">{{ tool.dailyRate | toCurrency }}</span> / Day</div>
                            <div class="mt1 f7 mid-gray">{{ tool.distance }} KM</div>
                        </div>
                        <div class="flex items-center" v-if="xs">
                            <div class="formLabel mid-gray mr1">{{tool.count}}</div>
                            <FixedRating :rating="tool.rating"/>
                        </div>

                    </div>
                </template>                
                <template slot="icon">
                    <div v-if="!xs">
                        <RatingBox v-if="tool.count !== 0" class="flex-none" :rating="tool.rating"/>
                        <NoRatingBox v-else/>
                    </div>
                </template>            
            </ToolListItem>
        </router-link>
    </div>
</template>

<script>
import RatingBox from '@/components/controls/RatingBox.vue';
import NoRatingBox from '@/components/controls/NoRatingBox.vue';
import FixedRating from '@/components/global/FixedRating.vue';
import ToolListItem from '@/components/global/ToolListItem.vue';
import { mapActions } from 'vuex';

export default {
    components: {
        RatingBox,
        NoRatingBox,
        FixedRating,
        ToolListItem
    },
    props: {
        tools: {
            type: Array,
            required: true
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    },
    methods: {
        ...mapActions('activeListings', ['addView'])
    }
};
</script>
